<template>
  <div class="my-member ios-padding-bottom">
    <div class="my-member-header" :class="headerClass[userVipData.vipLevel]">
      <div class="my-member-bg"></div>
      <div class="my-member-info">
        <img
          v-if="userVipData.vipLevel == 0"
          src="../../assets/member-icon/member-0.png"
          class="my-member-info-bg"
          alt=""
        />
        <img
          v-if="userVipData.vipLevel == 1"
          src="../../assets/member-icon/member-1.png"
          class="my-member-info-bg"
          alt=""
        />
        <img
          v-if="userVipData.vipLevel == 2"
          src="../../assets/member-icon/member-2.png"
          class="my-member-info-bg"
          alt=""
        />
        <img
          v-if="userVipData.vipLevel == 3"
          src="../../assets/member-icon/member-3.png"
          class="my-member-info-bg"
          alt=""
        />
        <img
          v-if="userVipData.vipLevel == 4"
          src="../../assets/member-icon/member-4.png"
          class="my-member-info-bg"
          alt=""
        />
        <div class="member-info-box">
          <div class="member-info-left">当前等级</div>
          <div class="member-info-title">{{ userVipData.vipName }}</div>
          <div class="member-time" v-if="userVipData.vipEndTime">
            {{ userVipData.vipEndTime }}
          </div>
          <div class="next-member" v-if="userVipData.nextVipName">
            {{ userVipData.nextVipName }} {{ userVipData.nextVipBeginTime }}生效
          </div>
        </div>
        <div class="info-box">
          <div class="info-flex">
            <div class="info-value">{{ userVipData.chargeTime || 0 }}</div>
            <div class="info-name">已优惠充电(次)</div>
          </div>
          <div class="info-flex">
            <div class="info-value">
              {{ userVipData.chargeDiscountAmount || 0 }}
            </div>
            <div class="info-name">已优惠金额(元)</div>
          </div>
          <div
            class="info-flex"
            v-if="userVipData.vipLevel != 0 && userVipData.vipLevel != 4"
          >
            <div class="info-value">
              {{ userVipData.chargeDiscountByNextLevelAmount || 0 }}
            </div>
            <div class="info-name">下一等级预估优惠金额(元)</div>
          </div>
        </div>
        <img
          class="three-icon"
          src="../../assets/member-icon/three.png"
          alt=""
        />
      </div>
      <div class="my-member-text" v-if="userVipData.vipLevel == 0">
        当前无优惠，开通即享受优惠
      </div>
      <div class="my-member-text" v-else>
        尊贵的{{ userVipData.vipName }}，您享有充电{{
          userVipData.discountAmountTypelDesc || ""
        }}{{ (userVipData.discountRatio * 10) | toFixed }}折优惠
      </div>
    </div>
    <div class="member-purchase">
      <!-- <div class="member-purchase-title">
        <div class="title">升级会员
          <img class="wen" src="../../assets/image/wen-b.png" alt="" />
        </div>
      </div> -->
      <div class="member-list">
        <template v-for="(item, index) in vipList">
          <div
            class="member-item"
            v-if="item.vipLevel > userVipData.vipLevel"
            @click="vipClick(item)"
            :class="'member-item-' + item.vipLevel"
            :key="index"
          >
            <template v-if="item.vipLevel == 1">
              <img
                class="member-item-bg"
                v-if="userVipData.vipLevel <= item.vipLevel"
                src="../../assets/member-icon/member-icon-1.png"
                alt=""
              />
              <img
                class="member-item-bg"
                v-else
                src="../../assets/member-icon/member-icon-1-no.png"
                alt=""
              />
            </template>
            <template v-if="item.vipLevel == 2">
              <img
                class="member-item-bg"
                v-if="userVipData.vipLevel <= item.vipLevel"
                src="../../assets/member-icon/member-icon-2.png"
                alt=""
              />
              <img
                class="member-item-bg"
                v-else
                src="../../assets/member-icon/member-icon-2-no.png"
                alt=""
              />
            </template>
            <template v-if="item.vipLevel == 3">
              <img
                class="member-item-bg"
                v-if="userVipData.vipLevel <= item.vipLevel"
                src="../../assets/member-icon/member-icon-3.png"
                alt=""
              />
              <img
                class="member-item-bg"
                v-else
                src="../../assets/member-icon/member-icon-3-no.png"
                alt=""
              />
            </template>
            <template v-if="item.vipLevel == 4">
              <img
                class="member-item-bg"
                src="../../assets/member-icon/member-icon-4.png"
                alt=""
              />
            </template>
            <img
              class="active-icon"
              v-if="item.vipLevel == activeVip"
              src="../../assets/member-icon/member-active.png"
              alt=""
            />
            <div class="member-item-info">
              <div class="item-title">{{ item.vipName }}</div>
              <div class="item-value">
                {{ item.discountAmountTypeDesc
                }}{{ (item.discountRatio * 10) | toFixed }}折
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="member-day-list" style="padding: 0 0.2rem">
        <div class="member-day-item active" style="width: 100%; margin: 0">
          <div class="member-day-text">升级当前会员</div>
          <div class="member-day-info">
            <div class="day-money">{{ priceObj.priceDiff }}元</div>
            <div class="day-money-text orange">
              有效期至{{ priceObj.currDeadline }}
            </div>
          </div>
        </div>
      </div>
      <div class="btn-box">
        <!-- <div class="btn-text">开通即视为同意<text class="text-a">《派诺会员用户协议》</text></div> -->
        <pi-button
          v-if="priceObj.priceDiff != null"
          :type="loading ? 'loading' : 'primary'"
          block
          @click="confirmClick('2', priceObj.priceDiff)"
        >
          ¥{{ priceObj.priceDiff }} 立即升级
        </pi-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Popup } from "vant";
import {
  getUserVipList,
  getUserVipByUser,
  purchaseUserVip,
  getUserVipUpgradePrice,
} from "../../common/api";

export default {
  name: "my-member-upgrade",
  components: {
    [Popup.name]: Popup,
  },
  data() {
    return {
      headerClass: {
        0: "",
        1: "vip-1",
        2: "vip-2",
        3: "vip-3",
        4: "vip-4",
      },
      vip: 4,
      userVipData: {
        vipLevel: 0,
        vipName: "普通会员",
      },
      vipList: [],
      activeVip: "",
      activeVipObj: {},
      userPriceParams: [],
      userPriceActive: "",
      userPriceActiveObj: {},
      priceObj: {},
      loading: false,
    };
  },
  mounted() {
    this.getUserVipByUser();
  },
  methods: {
    async getUserVipByUser() {
      let ret = await getUserVipByUser({
        // accountPkId: this.$route.query.accountPkId
      });
      if (ret.status === this.$config.ajaxStatus) {
        this.userVipData = ret.data[0] || {};
      } else {
        this.$toast(ret.msg);
      }
      this.getUserVipList();
    },
    async getUserVipList() {
      let ret = await getUserVipList({});
      if (ret.status === this.$config.ajaxStatus) {
        this.vipList = ret.data || [];

        //this.userVipData
        let itemData = null;
        this.vipList.map((item) => {
          if (
            this.userVipData.vipLevel < item.vipLevel &&
            !itemData &&
            item.status
          ) {
            itemData = item;
          }
        });
        if (itemData) {
          this.vipClick(itemData);
        }
      } else {
        this.$toast(ret.msg);
      }
    },

    async purchaseUserVip(purchaseType, price) {
      this.loading = true;
      let ret = await purchaseUserVip({
        chargeUserPkId: this.$route.query.chargeUserPkId,
        discountAmountType: this.activeVipObj.discountAmountType,
        discountRatio: this.activeVipObj.discountRatio,
        vipLevel: this.activeVipObj.vipLevel,
        // firstTimePrice: this.userPriceActiveObj.price,
        points: 0,
        price: price,
        vipDays: 30,
        purchaseType: purchaseType,
        purchaseWay: 1,
      });
      if (ret.status === this.$config.ajaxStatus) {
        this.$toast("购买成功");
        this.$common.goBack();
        // this.getUserVipByUser();
      } else {
        this.$toast(ret.msg);
      }
      this.loading = false;
    },
    async getVipPrice(vipPkId) {
      let ret = await getUserVipUpgradePrice({
        vipPkId: vipPkId,
        chargeUserPkId: this.$route.query.chargeUserPkId,
      });
      if (ret.status === this.$config.ajaxStatus) {
        this.priceObj = ret.data[0] || {};
      } else {
        this.$toast(ret.msg);
      }
    },
    vipClick(item) {
      if (this.userVipData.vipLevel <= item.vipLevel) {
        this.activeVip = item.vipLevel;
        this.activeVipObj = item;
        this.getVipPrice(item.vipPkId);
      }
    },

    confirmClick(purchaseType, money) {
      this.$dialog
        .confirm({
          message: "确定要使用余额购买该会员吗",
          confirmButtonText: "确定",
          confirmButtonColor: "#14CC80",
          closeOnPopstate: true,
        })
        .then(() => {
          this.purchaseUserVip(purchaseType, money);
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>
<style lang="less">
@import url("../my-member/css/my-member.less");
</style>
